import { lazier } from '@shared/components';

export const HikeModal = lazier(() => import('./HikeModal'), false);
export { default as RecordHikeMilesButton } from './RecordHikeMilesButton';
export { default as CreateHikeButton } from './CreateHikeButton';
export { default as EditHikeButton } from './EditHikeButton';
